import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * ?new=1 opens a register's add form — how the search box's actions ("Add a
 * risk", "Record an incident") land on the form rather than the list
 * (nav/paletteActions.ts). The parameter is dropped once used, so a reload or
 * the back button does not open the form again. `ready` is the page's own
 * permission to add (and, where it matters, that the page has loaded): until it
 * is true the parameter waits, and the form never opens for someone the page
 * would not offer the button to.
 */
export function useNewFromLink(ready: boolean, openForm: () => void): void {
  const [searchParams, setSearchParams] = useSearchParams();
  const wanted = searchParams.get("new") === "1";
  useEffect(() => {
    if (!wanted || !ready) return;
    openForm();
    const next = new URLSearchParams(searchParams);
    next.delete("new");
    setSearchParams(next, { replace: true });
  }, [wanted, ready]); // eslint-disable-line react-hooks/exhaustive-deps
}
